(function webpackUniversalModuleDefinition(root, factory) {
  if (typeof exports === 'object' && typeof module === 'object') module.exports = factory(require("react"), require("classnames"), require("@material/ripple/dist/mdc.ripple.js"));else if (typeof define === 'function' && define.amd) define(["react", "classnames", "@material/ripple/dist/mdc.ripple.js"], factory);else {
    var a = typeof exports === 'object' ? factory(require("react"), require("classnames"), require("@material/ripple/dist/mdc.ripple.js")) : factory(root["react"], root["classnames"], root["@material/ripple/dist/mdc.ripple.js"]);

    for (var i in a) {
      (typeof exports === 'object' ? exports : root)[i] = a[i];
    }
  }
})(typeof self !== 'undefined' ? self : this, function (__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_62__) {
  return (
    /******/
    function (modules) {
      // webpackBootstrap

      /******/
      // The module cache

      /******/
      var installedModules = {};
      /******/

      /******/
      // The require function

      /******/

      function __webpack_require__(moduleId) {
        /******/

        /******/
        // Check if module is in cache

        /******/
        if (installedModules[moduleId]) {
          /******/
          return installedModules[moduleId].exports;
          /******/
        }
        /******/
        // Create a new module (and put it into the cache)

        /******/


        var module = installedModules[moduleId] = {
          /******/
          i: moduleId,

          /******/
          l: false,

          /******/
          exports: {}
          /******/

        };
        /******/

        /******/
        // Execute the module function

        /******/

        modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
        /******/

        /******/
        // Flag the module as loaded

        /******/

        module.l = true;
        /******/

        /******/
        // Return the exports of the module

        /******/

        return module.exports;
        /******/
      }
      /******/

      /******/

      /******/
      // expose the modules object (__webpack_modules__)

      /******/


      __webpack_require__.m = modules;
      /******/

      /******/
      // expose the module cache

      /******/

      __webpack_require__.c = installedModules;
      /******/

      /******/
      // define getter function for harmony exports

      /******/

      __webpack_require__.d = function (exports, name, getter) {
        /******/
        if (!__webpack_require__.o(exports, name)) {
          /******/
          Object.defineProperty(exports, name, {
            /******/
            configurable: false,

            /******/
            enumerable: true,

            /******/
            get: getter
            /******/

          });
          /******/
        }
        /******/

      };
      /******/

      /******/
      // getDefaultExport function for compatibility with non-harmony modules

      /******/


      __webpack_require__.n = function (module) {
        /******/
        var getter = module && module.__esModule ?
        /******/
        function getDefault() {
          return module['default'];
        } :
        /******/
        function getModuleExports() {
          return module;
        };
        /******/

        __webpack_require__.d(getter, 'a', getter);
        /******/


        return getter;
        /******/
      };
      /******/

      /******/
      // Object.prototype.hasOwnProperty.call

      /******/


      __webpack_require__.o = function (object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
      };
      /******/

      /******/
      // __webpack_public_path__

      /******/


      __webpack_require__.p = "";
      /******/

      /******/
      // Load entry module and return exports

      /******/

      return __webpack_require__(__webpack_require__.s = 61);
      /******/
    }(
    /************************************************************************/

    /******/
    {
      /***/
      0:
      /***/
      function _(module, exports) {
        module.exports = __WEBPACK_EXTERNAL_MODULE_0__;
        /***/
      },

      /***/
      1:
      /***/
      function _(module, exports) {
        module.exports = __WEBPACK_EXTERNAL_MODULE_1__;
        /***/
      },

      /***/
      61:
      /***/
      function _(module, exports, __webpack_require__) {
        "use strict";

        var __extends = this && this.__extends || function () {
          var _extendStatics = function extendStatics(d, b) {
            _extendStatics = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (d, b) {
              d.__proto__ = b;
            } || function (d, b) {
              for (var p in b) {
                if (b.hasOwnProperty(p)) d[p] = b[p];
              }
            };

            return _extendStatics(d, b);
          };

          return function (d, b) {
            _extendStatics(d, b);

            function __() {
              this.constructor = d;
            }

            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
          };
        }();

        var __assign = this && this.__assign || function () {
          __assign = Object.assign || function (t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
              s = arguments[i];

              for (var p in s) {
                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
              }
            }

            return t;
          };

          return __assign.apply(this, arguments);
        };

        var __rest = this && this.__rest || function (s, e) {
          var t = {};

          for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
          }

          if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
          }
          return t;
        };

        Object.defineProperty(exports, "__esModule", {
          value: true
        }); // The MIT License
        //
        // Copyright (c) 2018 Google, Inc.
        //
        // Permission is hereby granted, free of charge, to any person obtaining a copy
        // of this software and associated documentation files (the "Software"), to deal
        // in the Software without restriction, including without limitation the rights
        // to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
        // copies of the Software, and to permit persons to whom the Software is
        // furnished to do so, subject to the following conditions:
        //
        // The above copyright notice and this permission notice shall be included in
        // all copies or substantial portions of the Software.
        //
        // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
        // IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
        // FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
        // AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
        // LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
        // OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
        // THE SOFTWARE.

        var React = __webpack_require__(0);

        var classnames = __webpack_require__(1); // @ts-ignore no mdc .d.ts file


        var mdc_ripple_1 = __webpack_require__(62);

        var MATCHES = mdc_ripple_1.util.getMatchesProperty(HTMLElement.prototype);

        function isElement(element) {
          return element[MATCHES] !== undefined;
        } // This is an HOC that adds Ripple to the component passed as an argument


        function withRipple(WrappedComponent) {
          var _a;

          return _a =
          /** @class */
          function (_super) {
            __extends(RippledComponent, _super);

            function RippledComponent() {
              var _this = _super !== null && _super.apply(this, arguments) || this;

              _this.isComponentMounted = true;
              _this.displayName = "WithRipple(" + getDisplayName(WrappedComponent) + ")";
              _this.state = {
                classList: new Set(),
                style: {}
              }; // surface: This element receives the visual treatment (classes and style) of the ripple.
              // activator: This element is used to detect whether to activate the ripple. If this is not
              // provided, the ripple surface will be used to detect activation.

              _this.initializeFoundation = function (surface, activator) {
                var adapter = _this.createAdapter(surface, activator);

                _this.foundation = new mdc_ripple_1.MDCRippleFoundation(adapter);

                _this.foundation.init();
              };

              _this.createAdapter = function (surface, activator) {
                return {
                  browserSupportsCssVars: function browserSupportsCssVars() {
                    return mdc_ripple_1.util.supportsCssVariables(window);
                  },
                  isUnbounded: function isUnbounded() {
                    return _this.props.unbounded;
                  },
                  isSurfaceActive: function isSurfaceActive() {
                    if (activator) {
                      if (isElement(activator)) {
                        return activator[MATCHES](':active');
                      }

                      return false;
                    }

                    if (isElement(surface)) {
                      return surface[MATCHES](':active');
                    }

                    return false;
                  },
                  isSurfaceDisabled: function isSurfaceDisabled() {
                    return _this.props.disabled;
                  },
                  addClass: function addClass(className) {
                    if (!_this.isComponentMounted) {
                      return;
                    }

                    _this.setState({
                      classList: _this.state.classList.add(className)
                    });
                  },
                  removeClass: function removeClass(className) {
                    if (!_this.isComponentMounted) {
                      return;
                    }

                    var classList = _this.state.classList;
                    classList.delete(className);

                    _this.setState({
                      classList: classList
                    });
                  },
                  registerDocumentInteractionHandler: function registerDocumentInteractionHandler(evtType, handler) {
                    return document.documentElement.addEventListener(evtType, handler, mdc_ripple_1.util.applyPassive());
                  },
                  deregisterDocumentInteractionHandler: function deregisterDocumentInteractionHandler(evtType, handler) {
                    return document.documentElement.removeEventListener(evtType, handler, mdc_ripple_1.util.applyPassive());
                  },
                  registerResizeHandler: function registerResizeHandler(handler) {
                    return window.addEventListener('resize', handler);
                  },
                  deregisterResizeHandler: function deregisterResizeHandler(handler) {
                    return window.removeEventListener('resize', handler);
                  },
                  updateCssVariable: _this.updateCssVariable,
                  computeBoundingRect: function computeBoundingRect() {
                    if (!_this.isComponentMounted) {
                      // need to return object since foundation expects it
                      return {};
                    }

                    if (_this.props.computeBoundingRect) {
                      return _this.props.computeBoundingRect(surface);
                    }

                    return surface.getBoundingClientRect();
                  },
                  getWindowPageOffset: function getWindowPageOffset() {
                    return {
                      x: window.pageXOffset,
                      y: window.pageYOffset
                    };
                  }
                };
              };

              _this.handleFocus = function (e) {
                _this.props.onFocus && _this.props.onFocus(e);

                _this.foundation.handleFocus();
              };

              _this.handleBlur = function (e) {
                _this.props.onBlur && _this.props.onBlur(e);

                _this.foundation.handleBlur();
              };

              _this.handleMouseDown = function (e) {
                _this.props.onMouseDown && _this.props.onMouseDown(e);

                _this.activateRipple(e);
              };

              _this.handleMouseUp = function (e) {
                _this.props.onMouseUp && _this.props.onMouseUp(e);

                _this.deactivateRipple(e);
              };

              _this.handleTouchStart = function (e) {
                _this.props.onTouchStart && _this.props.onTouchStart(e);

                _this.activateRipple(e);
              };

              _this.handleTouchEnd = function (e) {
                _this.props.onTouchEnd && _this.props.onTouchEnd(e);

                _this.deactivateRipple(e);
              };

              _this.handleKeyDown = function (e) {
                _this.props.onKeyDown && _this.props.onKeyDown(e);

                _this.activateRipple(e);
              };

              _this.handleKeyUp = function (e) {
                _this.props.onKeyUp && _this.props.onKeyUp(e);

                _this.deactivateRipple(e);
              };

              _this.activateRipple = function (e) {
                // https://reactjs.org/docs/events.html#event-pooling
                e.persist();
                requestAnimationFrame(function () {
                  _this.foundation.activate(e);
                });
              };

              _this.deactivateRipple = function (e) {
                _this.foundation.deactivate(e);
              };

              _this.updateCssVariable = function (varName, value) {
                if (!_this.isComponentMounted) {
                  return;
                }

                _this.setState(function (prevState) {
                  var updatedStyle = Object.assign({}, _this.state.style);
                  updatedStyle[varName] = value;
                  return Object.assign(prevState, {
                    style: updatedStyle
                  });
                });
              };

              return _this;
            }

            RippledComponent.prototype.componentDidMount = function () {
              if (!this.foundation) {
                throw new Error('You must call initRipple from the element\'s ' + 'ref prop to initialize the adapter for withRipple');
              }
            };

            RippledComponent.prototype.componentWillUnmount = function () {
              if (this.foundation) {
                this.isComponentMounted = false;
                this.foundation.destroy();
              }
            };

            Object.defineProperty(RippledComponent.prototype, "classes", {
              get: function get() {
                var wrappedComponentClasses = this.props.className;
                var classList = this.state.classList;
                return classnames(Array.from(classList), wrappedComponentClasses);
              },
              enumerable: true,
              configurable: true
            });
            Object.defineProperty(RippledComponent.prototype, "style", {
              get: function get() {
                var wrappedStyle = this.props.style;
                var style = this.state.style;
                return Object.assign({}, style, wrappedStyle);
              },
              enumerable: true,
              configurable: true
            });

            RippledComponent.prototype.render = function () {
              var _a = this.props,

              /* eslint-disable */
              unbounded = _a.unbounded,
                  style = _a.style,
                  className = _a.className,
                  onMouseDown = _a.onMouseDown,
                  onMouseUp = _a.onMouseUp,
                  onTouchStart = _a.onTouchStart,
                  onTouchEnd = _a.onTouchEnd,
                  onKeyDown = _a.onKeyDown,
                  onKeyUp = _a.onKeyUp,
                  onFocus = _a.onFocus,
                  onBlur = _a.onBlur,

              /* eslint-enable */
              otherProps = __rest(_a, ["unbounded", "style", "className", "onMouseDown", "onMouseUp", "onTouchStart", "onTouchEnd", "onKeyDown", "onKeyUp", "onFocus", "onBlur"]);

              var updatedProps = __assign({}, otherProps, {
                onMouseDown: this.handleMouseDown,
                onMouseUp: this.handleMouseUp,
                onTouchStart: this.handleTouchStart,
                onTouchEnd: this.handleTouchEnd,
                onKeyDown: this.handleKeyDown,
                onKeyUp: this.handleKeyUp,
                onFocus: this.handleFocus,
                onBlur: this.handleBlur,
                initRipple: this.initializeFoundation,
                className: this.classes,
                style: this.style
              });

              return (// this issue is only appearing in TS v3.2.x. I am not seeing this issue appear in v2.9.1
                // @ts-ignore
                React.createElement(WrappedComponent, __assign({}, updatedProps))
              );
            };

            return RippledComponent;
          }(React.Component), _a.defaultProps = __assign({
            unbounded: false,
            disabled: false,
            style: {},
            className: '',
            onMouseDown: function onMouseDown() {},
            onMouseUp: function onMouseUp() {},
            onTouchStart: function onTouchStart() {},
            onTouchEnd: function onTouchEnd() {},
            onKeyDown: function onKeyDown() {},
            onKeyUp: function onKeyUp() {},
            onFocus: function onFocus() {},
            onBlur: function onBlur() {}
          }, WrappedComponent.defaultProps), _a;
        }

        exports.withRipple = withRipple;

        function getDisplayName(WrappedComponent) {
          return WrappedComponent.displayName || WrappedComponent.name || 'Component';
        }
        /***/

      },

      /***/
      62:
      /***/
      function _(module, exports) {
        module.exports = __WEBPACK_EXTERNAL_MODULE_62__;
        /***/
      }
      /******/

    })
  );
});